export default defineNuxtRouteMiddleware((to) => {
  const defaultLocale = useRuntimeConfig().public.i18n.defaultLocale || 'en'; // Default to 'en' if not set
  const currentPath = to.path;

  // Check if the route starts with the default locale
  if (currentPath === `/${defaultLocale}`) {
    return navigateTo('/'); // Redirect to root
  }
});